export const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['iphone', 'android', 'ipad', 'ipod', 'blackberry', 'windows phone'];
    const isSmallScreen = window.innerWidth <= 900;
    return mobileKeywords.some(keyword => userAgent.includes(keyword)) || isSmallScreen;
};